import { createFormGroupState } from 'ngrx-forms';

import type { SolarPanelsSuitabilityCheckFormValues } from './solar-panels-suitability-check-form-values.interface';

export const solarPanelsSuitabilityCheckKey = 'solarPanelSuitabilityCheck';
export const solarPanelsSuitabilityCheckFormId =
  'solarPanelSuitabilityCheckForm';

export const asbestosControlId = `${solarPanelsSuitabilityCheckFormId}.asbestos`;
export const roofTypeControlId = `${solarPanelsSuitabilityCheckFormId}.roofType`;
export const renewedRoofWithinTimeLimitControlId = `${solarPanelsSuitabilityCheckFormId}.renewedRoofWithinTimeLimit`;

const initialFormValues = {
  asbestos: undefined,
  roofType: undefined,
  renewedRoofWithinTimeLimit: undefined,
};

export const initialSolarPanelSuitabilityCheckFormState =
  createFormGroupState<SolarPanelsSuitabilityCheckFormValues>(
    solarPanelsSuitabilityCheckFormId,
    initialFormValues
  );
